import { Tab, Tabs } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import { useAllowedTabs } from 'app/hooks/useAccess'

import ApartmentAttendancePage from '../Attendance'
import ApartmentBatchesPage from '../Batches'
import ApartmentDashboardPage from '../Dashboard'
import ApartmentEnrolmentsPage from '../Enrolments'
import ApartmentFamilyDashboardPage from '../FamilyDashboard'
import ApartmentPaymentsPage from '../Payments'
import ApartmentPayoutPage from '../Payout'
import ApartmentPricingPage from '../Pricing'
import ApartmentTrialsPage from '../Trials'
import ApartmentWaitlistPage from '../Waitlist'

// The single-apartment workspace. Every section is a top tab (matching the
// rest of Alfred, e.g. HQ · Procurement) instead of 15 separate fly-out items.
// Each tab renders its existing page as-is — including that page's own header
// with the apartment selector + "New …" action — so nothing else changes.
const TABS = [
  { id: 'dashboard', label: 'Overview', Comp: ApartmentDashboardPage },
  {
    id: 'parent-dashboard',
    label: 'Parent Dashboard',
    Comp: ApartmentFamilyDashboardPage
  },
  { id: 'enrolments', label: 'Booking', Comp: ApartmentEnrolmentsPage },
  { id: 'batches', label: 'Batches', Comp: ApartmentBatchesPage },
  { id: 'attendance', label: 'Attendance', Comp: ApartmentAttendancePage },
  { id: 'trials', label: 'Trials', Comp: ApartmentTrialsPage },
  { id: 'waitlist', label: 'Waitlist', Comp: ApartmentWaitlistPage },
  { id: 'payments', label: 'Payments', Comp: ApartmentPaymentsPage },
  { id: 'pricing', label: 'Pricing', Comp: ApartmentPricingPage },
  { id: 'payout', label: 'Payout', Comp: ApartmentPayoutPage }
]

const TAB_KEY = 'apartment.perApartment.tab'

const useStyles = makeStyles((theme) => ({
  // Clip so a wide tab body scrolls inside itself instead of stretching the
  // page (same reason as the list pages).
  root: { minWidth: 0, overflowX: 'hidden' },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingLeft: theme.spacing(1)
  },
  // Let the tabs flow onto multiple rows instead of one scrollable line.
  tabsRow: { flexWrap: 'wrap' },
  tab: {
    minWidth: 'auto',
    minHeight: 44,
    '&.Mui-selected': { fontWeight: 600 }
  }
}))

const ApartmentPerApartment = () => {
  const classes = useStyles()
  // Only the tabs the user's role ticks (HQ -> Roles & Permissions ->
  // At Apartment -> Per Apartment). A remembered tab the role no longer holds
  // falls back to the first allowed one.
  const tabs = useAllowedTabs('apartmentManage', TABS)
  const [tab, setTab] = React.useState(
    () => window.localStorage.getItem(TAB_KEY) || 'dashboard'
  )

  React.useEffect(() => {
    window.localStorage.setItem(TAB_KEY, tab)
  }, [tab])

  const current = tabs.find((t) => t.id === tab) || tabs[0]
  if (!current) return null
  const Active = current.Comp

  return (
    <div className={classes.root}>
      <Tabs
        className={classes.tabs}
        classes={{ flexContainer: classes.tabsRow }}
        value={current.id}
        onChange={(e, v) => setTab(v)}
        textColor="primary"
        TabIndicatorProps={{ style: { display: 'none' } }}
      >
        {tabs.map((t) => (
          <Tab
            key={t.id}
            value={t.id}
            label={t.label}
            className={classes.tab}
          />
        ))}
      </Tabs>
      <Active />
    </div>
  )
}

export default ApartmentPerApartment
